/** Only same-app paths are allowed as post-login destinations (no open redirects). */
export function safeRedirect(target: unknown, fallback = "/"): string {
  if (typeof target !== "string" || !target.startsWith("/") || target.startsWith("//") || target.startsWith("/\\")) return fallback;
  if (target.startsWith("/login")) return fallback;
  return target;
}
